








import { Component, Vue } from 'vue-property-decorator'
const maxLeft = 75

import { PredictedScore } from '@/mixins/drillsv3/HistoryApi'

@Component
export default class PredictedScoreBar extends Vue {
  private mounted() {
    Vue.prototype.$logger.info('-- PredictedScore mounted')
  }

  // 理解度をストアから取得
  private get predictedScore(): PredictedScore | null {
    const predictedScores = this.$store.getters['drillsV3/predictedScores']
    // 先頭要素のみを使用する、平均理解度などを表示する場合は修正
    if (predictedScores.length > 0) {
      return predictedScores[0]
    }

    return null
  }

  // 理解度の下限
  private get minPredictedScore(): number {
    return Math.floor(this.predictedScore?.min || 0)
  }

  // 理解度の上限
  private get maxPredictedScore(): number {
    return Math.floor(this.predictedScore?.max || 0)
  }

  private get styles(): { [key: string]: string } {
    const startPosition = (this.minPredictedScore + this.maxPredictedScore) / 2 - 12.5
    let left
    if (startPosition < 0) {
      left = 0
    } else if (startPosition > maxLeft) {
      left = maxLeft
    } else {
      left = startPosition
    }
    return {
      left: `${left}%`,
    }
  }
}
